import { useState } from "react";
import { getAudioOutputDevices } from "../services/audioDevices.service";

export default function SpeakerController({ selected, onChange, toast }) {
  const [outputs, setOutputs] = useState([]);
  const [loading, setLoading] = useState(false);

  const toggle = (id) => {
    const next = selected.includes(id)
      ? selected.filter((x) => x !== id)
      : [...selected, id];
    onChange(next);
  };

  const loadDevices = async () => {
    setLoading(true);
    try {
      const devices = await getAudioOutputDevices();
      if (!devices.length) {
        toast({
          type: "warning",
          title: "No Audio Devices Found",
          message:
            "Make sure your Bluetooth speakers are paired and connected.",
          duration: 4000,
        });
      } else {
        setOutputs(devices);
        toast({
          type: "success",
          title: "Devices Loaded",
          message: `Found ${devices.length} audio output device${devices.length > 1 ? "s" : ""}.`,
          duration: 2500,
        });
      }
    } catch (err) {
      if (err?.name === "NotAllowedError") {
        toast({
          type: "error",
          title: "Permission Denied",
          message: "Allow microphone permission to enumerate audio devices.",
          duration: 5000,
        });
      } else {
        toast({
          type: "error",
          title: "Failed to Load Devices",
          message: err?.message ?? "Could not access audio devices.",
          duration: 4000,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="speaker-box">
      <h3>🎧 Select Bluetooth Output Devices</h3>

      <button
        className="btn connect"
        onClick={loadDevices}
        disabled={loading}
        style={{ marginBottom: 10 }}
      >
        {loading ? "⏳ Loading..." : "🔍 Load Audio Devices"}
      </button>

      {outputs.length > 0 && (
        <div className="device-list">
          {outputs.map((d) => (
            <label key={d.deviceId} className="device-item">
              <input
                type="checkbox"
                checked={selected.includes(d.deviceId)}
                onChange={() => toggle(d.deviceId)}
              />
              <span>{d.label || `Device ${d.deviceId.slice(0, 8)}`}</span>
            </label>
          ))}
        </div>
      )}

      {outputs.length > 0 && selected.length > 0 && (
        <div className="device-selected-hint">
          {selected.length} device{selected.length > 1 ? "s" : ""} selected
        </div>
      )}
    </div>
  );
}
